var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHome(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M12.1924087,3.00119603 C12.7434087,3.00219603 13.2754087,3.22019603 13.6764087,3.61319603 L13.6764087,3.61319603 L22.1104087,11.885196 C22.4254087,12.195196 22.4304087,12.701196 22.1214087,13.017196 C21.8114087,13.332196 21.3044087,13.336196 20.9904087,13.028196 L20.9904087,13.028196 L19.6754087,11.738196 L19.6754087,20.344196 C19.6754087,20.786196 19.3174087,21.144196 18.8754087,21.144196 L18.8754087,21.144196 L5.47440875,21.144196 C5.03340875,21.144196 4.67540875,20.786196 4.67540875,20.344196 L4.67540875,20.344196 L4.67540875,11.736196 L3.36040875,13.027196 C3.20440875,13.180196 3.00240875,13.256196 2.80040875,13.256196 C2.59340875,13.256196 2.38640875,13.177196 2.22940875,13.017196 C1.91940875,12.702196 1.92440875,12.196196 2.23940875,11.886196 L2.23940875,11.886196 L10.6644087,3.60619603 C10.8634087,3.40919603 11.0994087,3.25419603 11.3654087,3.14919603 C11.6314087,3.04419603 11.9054087,2.99119603 12.1924087,3.00119603 Z M12.1574087,4.60019603 C12.0804087,4.60019603 12.0154087,4.61319603 11.9544087,4.63719603 C11.8914087,4.66219603 11.8354087,4.69819603 11.7884087,4.74519603 L11.7884087,4.74519603 L6.27440875,10.164196 L6.27440875,19.544196 L8.70040875,19.544196 L8.70040875,17.081196 C8.70040875,16.163196 9.06340875,15.300196 9.72340875,14.653196 C11.0334087,13.366196 13.3134087,13.364196 14.6274087,14.652196 C15.2874087,15.301196 15.6504087,16.163196 15.6504087,17.081196 L15.6504087,17.081196 L15.6504087,19.544196 L18.0754087,19.544196 L18.0754087,10.169196 L12.5564087,4.75619603 C12.4534087,4.65419603 12.2964087,4.59419603 12.1574087,4.60019603 Z M13.5064087,15.794196 C12.8074087,15.109196 11.5434087,15.109196 10.8444087,15.794196 C10.4934087,16.139196 10.3004087,16.596196 10.3004087,17.081196 L10.3004087,17.081196 L10.3004087,19.544196 L14.0504087,19.544196 L14.0504087,17.081196 C14.0504087,16.596196 13.8574087,16.139196 13.5064087,15.794196 Z M12.1759087,7.41209603 C13.5999087,7.41209603 14.7589087,8.55609603 14.7589087,9.96309603 C14.7589087,11.369096 13.5999087,12.513096 12.1759087,12.513096 C10.7509087,12.513096 9.59190875,11.369096 9.59190875,9.96309603 C9.59190875,8.55609603 10.7509087,7.41209603 12.1759087,7.41209603 Z M12.1759087,9.01209603 C11.6329087,9.01209603 11.1919087,9.43909603 11.1919087,9.96309603 C11.1919087,10.487096 11.6329087,10.914096 12.1759087,10.914096 C12.7179087,10.914096 13.1589087,10.487096 13.1589087,9.96309603 C13.1589087,9.43909603 12.7179087,9.01209603 12.1759087,9.01209603 Z",
    id: "path-5627d89d-3e08-491a-b363-cead0917e11e"
  }), /*#__PURE__*/React.createElement("linearGradient", {
    x1: "24.9776902%",
    y1: "2.77878783%",
    x2: "51.784702%",
    y2: "105.141587%",
    id: "linearGradient-5627d89d-3e08-491a-b363-cead0917e11e"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#7890C9",
    offset: "0%"
  }), /*#__PURE__*/React.createElement("stop", {
    stopColor: "#B19DD0",
    offset: "100%"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Icons",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Icons-/-Navigation-/-home"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-5627d89d-3e08-491a-b363-cead0917e11e",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-5627d89d-3e08-491a-b363-cead0917e11e"
  })), /*#__PURE__*/React.createElement("use", {
    id: "Icon-shape",
    fill: "#868B92",
    xlinkHref: "#path-5627d89d-3e08-491a-b363-cead0917e11e"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "Icon-color",
    fill: "url(#linearGradient-5627d89d-3e08-491a-b363-cead0917e11e)",
    mask: "url(#mask-5627d89d-3e08-491a-b363-cead0917e11e)",
    x: 0,
    y: 0,
    width: 24,
    height: 24
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHome);
export default __webpack_public_path__ + "static/media/home.8c7586fb574d655979feb1ed2b191623.svg";
export { ForwardRef as ReactComponent };